<template>
    <div class="login-container" :style="{ backgroundColor: theme.primaryColor, color: theme.textColor }">
      <div class="login-box">
        <div class="logoContainer">
        <img class="img3" src="../../assets/Cartago_Software_Sign.png" alt="Logo" style="margin: 12px;"/><img class="img4" src="../../assets/Cartago_Software_Name.png" alt="Logo" />
        </div>
        <div class="mainLogin">
          <div class="login-header" style="font-size: 1.2em;">
            <div style="display: flex; position: relative;">
          <h2>Reset Password</h2>
                        <md-button class="md-icon-button" @click="showDialog=true" style="    top: -11px;
    position: absolute;
    right: 0;">
                <md-icon style="color:#e94e1b;">info</md-icon>
            </md-button>

            </div>
  
          </div>

        <md-field :class="!validPass1 ? 'md-invalid' : ''">
            <label>Password</label>
            <md-input
                type="password"
                v-model="userPassData"
                required
            ></md-input>
            <span class="md-error">Enter a valid password</span>
        </md-field>
        <md-field :class="!validPass2 ? 'md-invalid' : ''">
          <label>Re-type Password</label>
          <md-input
            type="password"
            v-model="userRePassData"
            required
          ></md-input>
        <span class="md-error">Passwords do not match</span>

        </md-field>

        <md-button
          class="md-primary"
          :style="(!validPass1 || !validPass2)?'opacity:0.5; color:#808080!important;':''"
          @click="reset()"
          :disabled="!validPass1 || !validPass2" 
          >Set new password</md-button
        >

        </div>
        <div class="loginFooter">
          <div class="version" style="color: black;">Version 0.1.153</div>
 
        </div>
      </div>
  
      <div class="img-container">
        <img class="img" src="../../assets/Cartago_Software_BG.png" alt="Gebäudezeichnung" />
      </div>


     <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Password Help</md-dialog-title>
        <div class="dialog-content">

                <h4>The password must contain:</h4>
                <ul style="padding: 5px 30px"> 
                <li>Minimum eight characters</li>
                <li>At least one uppercase letter</li>
                <li>One lowercase letter</li>
                <li>One number</li>
                <li>One special character ({{ '@, $, !, %, *, ?, ' + '&, '+'#, '+'_'}})</li>
            </ul>
        </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    </div>
  </template>
  <script>
  
  import axios from "axios";
  import Vue from "vue";
  export default {
    
    data() {
      return {
              userPassData: "",
      userRePassData: "",
showDialog:false,

        theme:{
            primaryColor:'#fff',
            secondaryColor:'#e94e1b',
            textColor:'#e94e1b',
            name:'default'
        },
             
      };
    },
    created() {
    Vue.prototype.$userData = null;
    localStorage.setItem("generalConfiguration", "");
    localStorage.setItem("userData", "");
    localStorage.setItem("cacheRoute", "");
  },
    computed: {

    validPass1() {
        return   this.userPassData && this.userPassData.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#_])[A-Za-z\d@$!%*?&#_]{8,}$/);
      },
      validPass2() {
        return   this.userRePassData===this.userPassData;
      },
  },
    methods: {
    reset() {
        axios({
            method: "post",
            url: "/auth/reset-password"  ,
            baseURL: process.env.VUE_APP_BASE_API,
            data :{
              'password' : this.userPassData,
            },
            params: {
                'token':this.$route.query.token
            }
        }).then(() => {
            Vue.$toast.open({message : "User password changed successfully", position: 'bottom', type:  'success' });
            this.$router.push("Login");
        }).catch(function () {
            console.log("FAILURE!!");
        });
    },

    },
  };
  </script>
  <style scoped>
  /* Container für die Login-Maske */
  .login-container {
    display: flex;
    width: 100%;
    min-height: 100vh;
    font-family: 'Montserrat', sans-serif;
  }
  
  /* Linke Seite: Login-Box */
  .login-box {
    flex: 1;
    padding: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1)
  }
  
  .img2 {
    max-width: 200px;
  }
  
  .img3 {
    max-width: 70px;
  }

  .img4{
    max-width: 90px;
    display: block;
  }
  
  .mainLogin {
    margin: auto;
    width: 70%;
  }
  
  /* Modernisierte Formularfelder */
  .form-group {
    position: relative;
    margin-bottom: 25px;
  }

/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px white inset !important;
}
  
  .form-group input,
  .form-group select {
    width: 100%;
    height: 44px;
    padding: 10px 15px;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 16px;
    background: transparent;
    outline: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }
  
  .form-group input{
    width: 100%
  }
  
  .form-group select{
    height: 51px;
  }
  
  .form-group input:focus,
  .form-group select:focus {
    border-color: #e94e1b;
    box-shadow: 0 0 5px rgba(21, 119, 155, 0.5);
  }
  
  .form-group label {
    position: absolute;
    top: -10px;
    left: 15px;
    font-size: 14px;
    color: #e94e1b;
    background: #fff;
    padding: 0 5px;
    transition: color 0.3s ease, font-size 0.3s ease;
    pointer-events: none;
  }
  
  .form-group input:not(:placeholder-shown) + label,
  .form-group select:not(:placeholder-shown) + label {
    color: #e94e1b;
    font-size: 14px;
  }
  
  /* Modernisierte Schaltfläche */
  .submit-button {
    width: 100%;
    padding: 12px;
    background-color: #e94e1b;
    color: #fff;
    border: none;
    border-radius: 5px;
    font-size: 18px;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.1s ease;
    height: 50px;
  }
  
  .submit-button:hover {
    background-color: #0e4b5f;
  }
  
  .submit-button:active {
    transform: scale(0.98);
  }
  
  /* Rechte Seite: Bild */
  .img-container {
    flex: 2;
    height: 100vh;
    overflow: hidden;
  }
  
  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .login-icons {
    display: flex;
    gap: 15px;
    position: relative;
  }
  
  .icon-button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 24px;
    color: #666;
    transition: color 0.3s ease, transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .icon-button:hover {
    color: #e94e1b;
    transform: scale(1.1); /* Vergrößert das Icon leicht bei Hover */
  }
  
  .icon-button:active {
    transform: scale(0.95); /* Drückt das Icon leicht bei Klick */
  }
  
  .login-header{
    margin-bottom: 60px;
  }
  
  .loginFooter{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  
  .icon {
    font-size:26px;
  }
  
  /* Tooltip */
  .tooltip {
    position: absolute;
    bottom: 130%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: #fff;
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 4px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    white-space: nowrap;
  }
  
  .icon-button:hover .tooltip {
    opacity: 1;
    visibility: visible;
  }

  .language-popup {
  position: absolute;
  bottom: 30px;
  left: 7px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.dropdown-item {
  padding: 8px 16px;
  cursor: pointer;
  white-space: nowrap;
  color: black;
  font-weight: bold;
}

.dropdown-item:hover {
  background-color: #f1f1f1;
}
  
  </style> 
  